module.exports = __webpack_public_path__ + "static/media/market.badf9eb5.jpg";